var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowSquareLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-square-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/arrow-square-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-square-left_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 30.3334H12C4.76002 30.3334 1.66669 27.2401 1.66669 20.0001V12.0001C1.66669 4.76008 4.76002 1.66675 12 1.66675H20C27.24 1.66675 30.3334 4.76008 30.3334 12.0001V20.0001C30.3334 27.2401 27.24 30.3334 20 30.3334ZM12 3.66675C5.85335 3.66675 3.66669 5.85341 3.66669 12.0001V20.0001C3.66669 26.1467 5.85335 28.3334 12 28.3334H20C26.1467 28.3334 28.3334 26.1467 28.3334 20.0001V12.0001C28.3334 5.85341 26.1467 3.66675 20 3.66675H12Z",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.68 21.7066C17.4267 21.7066 17.1734 21.6133 16.9734 21.4133L12.2667 16.7066C11.88 16.32 11.88 15.68 12.2667 15.2933L16.9734 10.5866C17.36 10.2 18 10.2 18.3867 10.5866C18.7734 10.9733 18.7734 11.6133 18.3867 12L14.3867 16L18.3867 20C18.7734 20.3866 18.7734 21.0266 18.3867 21.4133C18.2 21.6133 17.9467 21.7066 17.68 21.7066Z",
    fill: "#9D9D9D"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSquareLeft);
export default __webpack_public_path__ + "static/media/arrow-square-left.820f13c4efa1f55d5e0a61828b86a1f8.svg";
export { ForwardRef as ReactComponent };